import Tile6Up from './Tile6Up';

export { default as Tile6UpMultirow } from './Tile6UpMultirow';
export { default as Tile6UpPromo } from './Tile6UpPromo';
export { default as Tile6UpShoppable } from './Tile6UpShoppable';
export { default as Tile6UpVisualNav } from './Tile6UpVisualNav';
export { default as Tile6UpTips } from './Tile6UpTips';
export { VisualNavigation } from './VisualNavigation';

export * from './types';

export default Tile6Up;
